module.exports = __webpack_public_path__ + "static/media/directcc_1004.42c83e28.ico";